/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = require('./_shared')('native-function-to-string', Function.toString);

